<!-- ── Top summary bar ─────────────────────────────────────── -->
<div class="rgi-summary-bar">

    <div class="rgi-card rgi-car-block">
        <img [src]="rideDetails.carImageUrl" alt="car" class="rgi-car-img" />
        <div class="rgi-car-meta">
            <span class="rgi-car-label">VEHICLE ID</span>
            <a class="rgi-link" [routerLink]="['/vehicles', rideDetails.carId]" (click)="onVehicleClick($event, rideDetails.carId)">
                #{{ rideDetails.carId }}
            </a>
            <span class="rgi-car-label" style="margin-top:4px">PLATE NUMBER</span>
            <button class="rgi-link" (click)="goToVehiclePage(rideDetails.plateNo)">
                {{ rideDetails.plateNo }}
            </button>
        </div>
    </div>

    <div class="rgi-card rgi-stat">
        <img src="assets/icons/pricing-plan.svg" alt="" width="23" height="23" class="rgi-stat-icon" />
        <div class="rgi-stat-body gap-2">
            <span class="rgi-stat-label">PRICING PLAN</span>
            <span class="rgi-stat-value">{{ rideDetails.originalPricingPlanName || '---' }}</span>
        </div>
    </div>

    <div class="rgi-card rgi-stat">
        <img src="assets/icons/distance-icon.svg" alt="" width="23" height="23" class="rgi-stat-icon" />
        <div class="rgi-stat-body gap-2">
            <span class="rgi-stat-label">DISTANCE</span>
            <span class="rgi-stat-value">{{ rideDetails.distanceKm }} <small>km driven</small></span>
        </div>
    </div>

    <div class="rgi-card rgi-stat">
        <img src="assets/icons/Timer.svg" alt="" width="23" height="23" class="rgi-stat-icon" />
        <div class="rgi-stat-body gap-2">
            <span class="rgi-stat-label">DURATION</span>
            <span class="rgi-stat-value">{{ rideDetails.durationSeconds | duration }}</span>
        </div>
    </div>

</div>

<!-- ── Main info grid ──────────────────────────────────────── -->
<div class="rgi-grid">

    <!-- Ride Information -->
    <div class="rgi-section">
        <h4 class="rgi-section-title">Ride Information</h4>
        <div class="rgi-rows">
            <div class="rgi-row">
                <span class="rgi-row-label">Start Time</span>
                <span class="rgi-row-value">
                    @if (rideDetails.startedAt) {
                        {{ rideDetails.startedAt | date:'MM/dd/yyyy hh:mm:ss a' }}
                    } @else { --- }
                </span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">End Time</span>
                <span class="rgi-row-value">
                    @if (rideDetails.endedAt) {
                        {{ rideDetails.endedAt | date:'MM/dd/yyyy hh:mm:ss a' }}
                    } @else { --- }
                </span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">End Reason</span>
                <span class="rgi-row-value">
                    {{ rideDetails.endReason ? (rideDetails.endReason | capitalize) : '---' }}
                </span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">End Location</span>
                <button class="rgi-link" (click)="openEndLocation()">Show</button>
            </div>
        </div>
    </div>

    <!-- Customer Information -->
    <div class="rgi-section">
        <h4 class="rgi-section-title">Customer Information</h4>
        <div class="rgi-rows">
            <div class="rgi-row">
                <span class="rgi-row-label">Customer ID</span>
                <a class="rgi-link" [routerLink]="['/customers', rideDetails.customerId]" (click)="onCustomerClick($event, rideDetails.customerId)">
                    {{ rideDetails.customerId }}
                </a>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">Full Name</span>
                <span class="rgi-row-value">
                    {{ rideDetails.customerFirstName }} {{ rideDetails.customerLastName }}
                </span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">Email</span>
                <span class="rgi-row-value">{{ rideDetails.customerEmail || '---' }}</span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">Phone</span>
                <span class="rgi-row-value">{{ rideDetails.customerPhoneNumber || '---' }}</span>
            </div>
        </div>
    </div>

    <!-- Payment Summary -->
    <div class="rgi-section">
        <h4 class="rgi-section-title">Payment Summary</h4>
        <div class="rgi-rows">
            <div class="rgi-row">
                <span class="rgi-row-label">Total Expected Amount</span>
                <span class="rgi-row-value">AED {{ rideDetails.totalExpectedAmount }}</span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">Total Collected Amount</span>
                <span class="rgi-row-value">AED {{ rideDetails.totalCollectedAmount }}</span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">Total Wallet Amount</span>
                <span class="rgi-row-value">AED {{ rideDetails.totalWalletAmount }}</span>
            </div>
            <div class="rgi-row">
                <span class="rgi-row-label">Total Card Amount</span>
                <span class="rgi-row-value">AED {{ rideDetails.totalCardAmount }}</span>
            </div>
        </div>
    </div>

</div>

<!-- ── Bottom: Trajectory + Parking photo ─────────────────── -->
<div class="rgi-bottom">

    <!-- Ride Trajectory -->
    <div class="rgi-map-card">
        <h4 class="rgi-section-title">Ride Trajectory</h4>

        @if (!trajectoryLoaded) {
        <div class="rgi-map-loading">
            <span>Loading trajectory...</span>
        </div>
        } @else if (!hasTrajectory) {
        <div class="rgi-map-loading">
            <span>No trajectory data available</span>
        </div>
        } @else {
        <div class="rgi-inline-map" role="button" tabindex="0" (click)="openRideTrajectoryDialog()" (keydown.enter)="openRideTrajectoryDialog()">
            <div class="rgi-map-overlay" title="Click to expand"></div>
            <google-map #inlineMapRef [center]="mapCenter" [zoom]="13" width="100%" height="100%" [options]="{ disableDefaultUI: true }" (mapInitialized)="onMapReady($event)">

                <!-- Dashed curved line from start to end -->
                @if (curvedPath.length) {
                <map-polyline [path]="curvedPath" [options]="{
                    geodesic: true,
                    strokeColor: '#2196f3',
                    strokeOpacity: 0,
                    icons: [{
                        icon: { path: 'M 0,-1 0,1', strokeOpacity: 1, strokeColor: '#2196f3', scale: 3 },
                        offset: '0',
                        repeat: '14px'
                    }]
                }" />
                }

                <!-- Start marker -->
                @if (startPoint) {
                <map-marker [position]="startPoint" [options]="{
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 10,
                        fillColor: '#22c55e',
                        fillOpacity: 1,
                        strokeWeight: 2,
                        strokeColor: '#fff'
                    },
                    label: { text: 'S', color: '#fff', fontWeight: '700', fontSize: '11px' },
                    zIndex: 10
                }" />
                }

                <!-- End marker -->
                @if (endPoint) {
                <map-marker [position]="endPoint" [options]="{
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 10,
                        fillColor: '#ef4444',
                        fillOpacity: 1,
                        strokeWeight: 2,
                        strokeColor: '#fff'
                    },
                    label: { text: 'E', color: '#fff', fontWeight: '700', fontSize: '11px' },
                    zIndex: 10
                }" />
                }

            </google-map>
        </div>
        }
    </div>

    <!-- Parking Photo -->
    <div class="rgi-photo-card">
        <div class="rgi-photo-header">
            <h4 class="rgi-section-title" style="margin:0;border-radius:0;border:none;background:none;padding:0">Parking Photo</h4>
            @if (photos.length > 0) {
            <span class="rgi-photo-counter">{{ photoIndex + 1 }} of {{ photos.length }}</span>
            }
        </div>
        @if (photos.length > 0) {
        <div class="rgi-slider">
            <button class="rgi-slider-btn" (click)="prevPhoto()" [disabled]="photos.length <= 1">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12 15L7 10L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <div class="rgi-slider-img-wrap">
                <button type="button" class="rgi-slider-img-btn" (click)="openLightbox(photoIndex)">
                    <img [src]="photos[photoIndex]" alt="parking photo" class="rgi-slider-img" />
                </button>
            </div>
            <button class="rgi-slider-btn" (click)="nextPhoto()" [disabled]="photos.length <= 1">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        } @else {
        <div class="rgi-no-photo">
            <img src="assets/icons/camera-icon.svg" alt="" width="24" height="24" style="opacity:.3" />
            <span>No parking photos available</span>
            <small>Photos will be captured when the ride is completed</small>
        </div>
        }
    </div>

</div>

<!-- Parking photo lightbox -->
<p-dialog [(visible)]="lightboxVisible" [style]="{ width: '56rem' }" [breakpoints]="{ '768px': '95vw' }"
    [closable]="true" [modal]="true" [draggable]="false" [dismissableMask]="true" header="Parking Photos">

    <div class="lightbox-body">
        <img [src]="photos[lightboxIndex]" alt="parking photo" class="lightbox-main-img" />

        <div class="lightbox-nav">
            <button class="lightbox-nav-btn" (click)="lightboxPrev()" [disabled]="photos.length <= 1">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                    <path d="M12 15L7 10L12 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <span class="lightbox-counter">{{ lightboxIndex + 1 }} / {{ photos.length }}</span>
            <button class="lightbox-nav-btn" (click)="lightboxNext()" [disabled]="photos.length <= 1">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                    <path d="M8 5L13 10L8 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>

        <div class="lightbox-thumbs">
            @for (photo of photos; track $index) {
            <button type="button" class="lightbox-thumb-btn" (click)="lightboxIndex = $index">
                <img [src]="photo" alt="thumb" class="lightbox-thumb" [class.active]="$index === lightboxIndex" />
            </button>
            }
        </div>
    </div>

</p-dialog>

@defer (when rideTrajectoryDialog; prefetch on idle) {
<app-ride-trajectory-form [ride]="rideDetails" [zoom]="17" [(visibility)]="rideTrajectoryDialog" />
}

@defer (when endLocationDialog; prefetch on idle) {
<app-show-location-dialog [lat]="rideDetails.telemetryEndLat" [lng]="rideDetails.telemetryEndLng"
    [zoom]="17" [(visibility)]="endLocationDialog" />
}
